













import Vue from 'vue'
import { Route } from 'vue-router'
import myHeader from '@/components/desktop-header.vue'
import myFooter from '@/components/desktop-footer.vue'
import pagename from '@/components/desktop-pagename.vue'
// import TsWrapper from '@/utils/typesquare'
// const Ts = new TsWrapper()

export default Vue.extend({
  components: { myHeader, myFooter, pagename },
  data() {
    return {
      transitionName: '',
      isHome: true
    }
  },
  
  // methods: {
  //   beforeEnter() {
  //     Ts.loadFont()
  //   }
  // },

  created() {
    this.isHome = this.$route.name === 'home' ? true : false
  },

  watch: {
    $route(to: Route, from: Route) {
      if (to.name !== 'home') {
        this.transitionName = from.meta.pid < to.meta.pid ? 'slide-next' : 'slide-prev'
        this.isHome = false
      } else {
        this.isHome = true
      }
    }
  }
})
